(function (ng, app) {

    Support2Controller.$inject = ["$mdDialog", "emailApi", "figToaster", "$scope"];
    app.controller("Support2Controller", Support2Controller);
    function Support2Controller($mdDialog, emailApi, figToaster, $scope) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    loading: false,
                },
                requestTypes: [
                    { Id: '1', Value: "General Info" },
                    { Id: '2', Value: "FIG Hosting" },
                    { Id: '3', Value: "Email Service" },
                    { Id: '4', Value: "Domain Name" },
                    { Id: '5', Value: "Website Design" },
                    { Id: '6', Value: "Website Updates" }
                ],
            });

        $ctrl.close = function ($event) {
            $mdDialog.hide($event);
        }

        $ctrl.submitTicket = function ($event) {
            $ctrl.ui.loading = true;
            var d = new Date();
            var time = d.toLocaleTimeString();
            var date = d.toLocaleDateString();
            var year = d.getFullYear();
            var phoneNumber = $ctrl.userInfo.Phone || "No number given";
            var message, toastClass;

            var body = "<html>" +
                "<head>" +
                "<meta charset='utf-8'>" +
                "<title>FIG Agent Portal Support Message</title>" +
                "</head>" +
                "<body>" +
                "<table width='80%' align='center' cellpadding='0' cellspacing='0'>" +
                "<tr>" +
                "<td height='80'><span style='display:block; font-size: 25px;' />FIG Agent Portal Support Request</span><br></td>" +
                "</tr>" +
                "<tr>" +
                "<td style='border:#ddd 1px solid;'></td>" +
                "</tr>" +
                "<tr>" +
                "<td style='padding:20px 20px; font-family:Arial, Helvetica, sans-serif; color:#5B5B5B ; line-height:18px;'>" +
                "<p>The following support request was submitted via the agent portal at " + time + " on " + date + "</p>" +
                "<p><strong>Full Name:</strong> " + $ctrl.userInfo.FullName + "</p>" +
                "<p><strong>Email: </strong> " + $ctrl.userInfo.Email + "</p>" +
                "<p><strong>Phone: </strong> " + phoneNumber + "</p>" +
                //"<p><strong>Request Type: </strong> " + $ctrl.requestType.Value + "</p>" +
                "<p><strong>Message: </strong> " + $ctrl.message + "</p>" +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td style='border:#ddd 1px solid;'></td>" +
                "</tr>" +
                "<tr>" +
                "<td height='30' align='center' style='font-family:Arial, Helvetica, sans-serif; font-size:10px; color:#5B5B5B ;'>" +
                "Copyright &copy; " + year + "  All Rights Reserved. <a href='http://www.figmarketing.com'><font color='#5B5B5B '>Financial Independence Group, Inc.</font></font></a>" +
                "</td>" +
                "</tr>" +
                "</table>" +
                "</body>" +
                "</html>";

            var email = {
                //Subject: "FIG Support - " + $ctrl.requestType.Value + " - " + $ctrl.userInfo.FullName,
                Subject: "FIG Agent Portal Support Request - " + $ctrl.userInfo.FullName,
                Body: body
            };

            emailApi.createAndSendSupportEmail(email, $event)
                .then(function (response) {
                    message = "Ticket submitted successfully!";
                    toastClass = "is-success";
                    $mdDialog.hide(response);
                })
                .catch(function (error) {
                    message = "There was a problem sending your ticket. Please try again shortly.";
                    toastClass = "is-error";
                    $mdDialog.cancel(error);
                })
                .finally(function () {
                    figToaster.showSimple(message, "top", toastClass);
                });
        }
        $ctrl.$onInit = function () {
            $ctrl.userInfo.FullName = $ctrl.userInfo.FirstName + " " + $ctrl.userInfo.LastName;
        };
    }
})(window.angular, window.app); //jshint ignore:line